import React, { useState } from 'react';
import { DateRange, Range, RangeKeyDict } from 'react-date-range';
import moment from 'moment';
import './rides-date-range-picker.scss';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import closeIcon from '../../../../assets/close.svg';
import Popup from 'reactjs-popup';
import { Button } from '@own/fds-react';
import { useBreakpoints } from '../../../../hooks/use-breakpoints';

interface Props {
    setDateState: (data: Range[]) => void;
    dateState: Range[];
    getModalState: (data: boolean) => void;
    datePickerCtaText: string;
}
const callAll = (...func: Function[]) => (data: RangeKeyDict | boolean) => {
    func.forEach(fun =>
        fun?.(typeof data === 'boolean' ? data : [data.selection])
    );
};
function RidesDateRangePicker(props: Props) {
    const { mobile } = useBreakpoints();
    const [isModelOpen, setModelOpen] = useState(false);
    const [state, setState] = useState<Range[]>([
        {
            startDate: moment()
                .subtract(1, 'months')
                .toDate(),
            endDate: moment().toDate(),
            key: 'selection',
        },
    ]);
    const format = 'DD/MM/YYYY';

    function position() {
        return mobile ? 'bottom center' : 'bottom right';
    }

    const handleOnChange = callAll(setState, props.setDateState);

    const handleModalState = callAll(setModelOpen, props.getModalState);

    const onState = props.dateState || state;

    const renderDateRangePicker = () => {
        return (
            <div className="rides-date-range-picker">
                <div className="date-range-input__wrapper">
                    <Popup
                        modal={mobile}
                        lockScroll={!mobile}
                        position={position()}
                        closeOnDocumentClick
                        onOpen={() => handleModalState(true)}
                        onClose={() => {
                            const dateRangeInputDiv = document.querySelector(
                                '.input__wrapper'
                            ) as HTMLDivElement;
                            dateRangeInputDiv?.focus();
                            handleModalState(false);
                        }}
                        open={isModelOpen}
                        arrow={true}
                        className="date-ranger-placeholder"
                        trigger={() => {
                            return (
                                <div
                                    role="textbox"
                                    className="input__wrapper"
                                    tabIndex={0}
                                    onKeyDown={event => {
                                        if (event.key === 'Enter') {
                                            handleModalState(!isModelOpen);
                                        }
                                    }}
                                >
                                    <input
                                        tabIndex={-1}
                                        name="datePickerInput"
                                        className="date-range-input left"
                                        type="text"
                                        readOnly
                                        value={
                                            onState[0]['startDate'] &&
                                            moment(
                                                props.dateState[0]['startDate']
                                            )
                                                .format(format)
                                                .toString()
                                        }
                                    />
                                    <hr className="date-seperator" />
                                    <input
                                        tabIndex={-1}
                                        name="datePickerInput"
                                        className="date-range-input right"
                                        type="text"
                                        readOnly
                                        value={
                                            onState[0]['endDate'] &&
                                            moment(
                                                props.dateState[0]['endDate']
                                            )
                                                .format(format)
                                                .toString()
                                        }
                                    />
                                </div>
                            );
                        }}
                    >
                        <div className="date-range-wrapper">
                            <div className="modal-close-wrapper">
                                <button
                                    onClick={() => setModelOpen(false)}
                                    aria-label="Close Dialog"
                                    className="modal-close"
                                >
                                    <img
                                        src={closeIcon}
                                        alt=""
                                        className="close-icon"
                                    />
                                </button>
                            </div>
                            <DateRange
                                onChange={handleOnChange}
                                moveRangeOnFirstSelection={false}
                                ranges={onState}
                                months={2}
                                direction={mobile ? 'vertical' : 'horizontal'}
                                showDateDisplay={false}
                                maxDate={moment().toDate()}
                                minDate={moment()
                                    .subtract(1, 'year')
                                    .toDate()}
                                classNames={{
                                    day: 'rdrDay-ride',
                                    inRange: 'rdrInRange-ride',
                                    startEdge: 'rdrStartEdge-ride',
                                    endEdge: 'rdrEndEdge-ride',
                                    dayHovered: 'rdrDayHovered-ride',
                                    dayStartPreview: 'rdrDayStartPreview-ride',
                                    dayEndPreview: 'rdrDayEndPreview-ride',
                                    monthPicker: 'rdrMonthPicker-ride',
                                    yearPicker: 'rdrYearPicker-ride',
                                    monthName: 'rdrMonthName-ride',
                                    weekDays: 'rdrWeekDays-ride',
                                    weekDay: 'rdrWeekDay-ride',
                                    prevButton: 'rdrPprevButton-ride',
                                    nextButton: 'rdrNextButton-ride',
                                }}
                                scroll={{
                                    enabled: mobile ? true : false,
                                }}
                            />
                            <Button
                                label={props.datePickerCtaText || 'Update'}
                                noShadow={false}
                                outlined={false}
                                theme="light"
                                onClick={() => setModelOpen(false)}
                                type="standard"
                            />
                        </div>
                    </Popup>
                </div>
            </div>
        );
    };
    return renderDateRangePicker();
}

export default RidesDateRangePicker;
